import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchAllQuestionsSuccessAction,
    fetchQuestionsByGroupSuccessAction,
    fetchQuestionsOfClaimTypeComboSuccessAction,
    fetchQuestionsSuccessAction,
} from '../actions/question';
type State = {
    question: {
        byId: { [id: string]: any } | {} | any;
        allIds: Array<string | any>;
    };
    loading: boolean;
    errorMessage: null | any;
    surveyQuestion?: {
        byId: { [id: string]: any } | {} | any;
        allIds: Array<string | any>;
    };
};
const INITIAL_STATE: State = {
    question: {
        byId: {},
        allIds: [],
    },
    loading: false,
    errorMessage: null,
    surveyQuestion: {
        byId: {},
        allIds: [],
    },
};

const fetchQuestions = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchQuestionsSuccess = (
    state: State,
    action: PayloadAction<fetchQuestionsSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload.body.data,
    );
    return {
        ...state,
        loading: false,
        question: {
            ...state.question,
            byId: {
                ...state.question.byId,
                ...byId,
            },
            allIds: GENERAL_FUNCTIONS.mergeArraysUnique(
                state.question.allIds,
                allIds,
            ),
        },
    };
};

const fetchQuestionsFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const fetchAllQuestions = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchAllQuestionsSuccess = (
    state: State,
    action: PayloadAction<fetchAllQuestionsSuccessAction>,
) => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        question: {
            ...state.question,
            byId,
            allIds,
        },
    };
};

const fetchAllQuestionsFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const clearQuestionState = (): State => {
    return INITIAL_STATE;
};

const fetchQuestionsOfClaimTypeCombo = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchQuestionsOfClaimTypeComboSuccess = (
    state: State,
    action: PayloadAction<fetchQuestionsOfClaimTypeComboSuccessAction>,
) => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        question: {
            ...state.question,
            byId: {
                ...state.question.byId,
                ...byId,
            },
            allIds: GENERAL_FUNCTIONS.mergeArraysUnique(
                state.question.allIds,
                allIds,
            ),
        },
    };
};

const fetchQuestionsOfClaimTypeComboFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const fetchQuestionsByGroup = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchQuestionsByGroupSuccess = (
    state: State,
    action: PayloadAction<fetchQuestionsByGroupSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'code',
        action.payload.body.data,
    );
    return {
        ...state,
        loading: false,
        question: {
            ...state.question,
            byId: {
                ...state.question.byId,
                ...byId,
            },
            allIds: GENERAL_FUNCTIONS.mergeArraysUnique(
                state.question.allIds,
                allIds,
            ),
        },
    };
};

const fetchQuestionsByGroupFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const question = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_QUESTIONS]: fetchQuestions,
    [ActionTypes.FETCH_QUESTIONS_SUCCESS]: fetchQuestionsSuccess,
    [ActionTypes.FETCH_QUESTIONS_FAILED]: fetchQuestionsFailed,
    [ActionTypes.CLEAR_QUESTION_STATE]: clearQuestionState,
    [ActionTypes.REDIRECT_AFTER_CLAIM_SUBMIT]: clearQuestionState,
    [ActionTypes.FETCH_ALL_QUESTIONS]: fetchAllQuestions,
    [ActionTypes.FETCH_ALL_QUESTIONS_SUCCESS]: fetchAllQuestionsSuccess,
    [ActionTypes.FETCH_ALL_QUESTIONS_FAILED]: fetchAllQuestionsFailed,
    [ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO]:
        fetchQuestionsOfClaimTypeCombo,
    [ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_SUCCESS]:
        fetchQuestionsOfClaimTypeComboSuccess,
    [ActionTypes.FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_FAILED]:
        fetchQuestionsOfClaimTypeComboFailed,
    [ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP]: fetchQuestionsByGroup,
    [ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP_SUCCESS]:
        fetchQuestionsByGroupSuccess,
    [ActionTypes.FETCH_ALL_QUESTIONS_BY_GROUP_FAILED]:
        fetchQuestionsByGroupFailed,
});

export default question;
